import { environments } from './Constants'

/**
 * Exactly `<app>.dev-N.bhanzu.com`, capturing `dev-N` (the applause apps'
 * resolveApiUrl rule). Anchored at both ends, one label only, so shared dev,
 * production and a host that merely contains a dev-N name do not match.
 */
export const DEV_N_HOST_RE = /^[a-z0-9-]+\.(dev-\d+)\.bhanzu\.com$/

/**
 * The environment the app is served in, from its host name: which API it
 * calls and which comms-tool role manages it (helpers/permissions.js).
 *
 * A bookable `<app>.dev-N.bhanzu.com` host calls its own
 * `https://api.dev-N.bhanzu.com`; it is otherwise a dev environment, as the
 * applause apps' dev build is on it. Before this, such a host fell through
 * to production and would have called api.bhanzu.com.
 *
 * @param {string} [hostname]  defaults to the page's (tests pass one)
 */
const getEnvironmentVariables = (hostname = window.location.hostname) => {
    const devN = DEV_N_HOST_RE.exec((hostname || '').toLowerCase())
    if (devN)
        return {
            ...environments.dev,
            baseURL: `https://api.${devN[1]}.bhanzu.com`,
            redirectURL: `https://${hostname.toLowerCase()}`,
        }

    // Order matters: dev/stage domains contain "bhanzu.com" too, so the
    // specific hosts are tested before any prod fallback.
    if (hostname.includes(environments.dev.domain)) return environments.dev
    if (hostname.includes(environments.stage.domain)) return environments.stage
    if (hostname.includes(environments.prod.domain)) return environments.prod

    // Explicit dev/stage suffixes, for hosts that are not the comms.* names --
    // e.g. the unlisted x7k2m9.dev.bhanzu.com if one is ever added.
    if (hostname.includes('.dev.bhanzu.com')) return environments.dev
    if (hostname.includes('.stage.bhanzu.com')) return environments.stage

    // Any other *.bhanzu.com host is PROD.
    //
    // This branch exists because the revamped tool is deployed on an unlisted
    // host (x7k2m9.bhanzu.com) that matches none of the comms.* domains above.
    // The old fallback returned environments.dev, so the app would have loaded
    // on a prod host and silently talked to api.dev.bhanzu.com -- showing dev
    // data, or an empty tool, with no error to explain why.
    if (hostname.endsWith('bhanzu.com')) return environments.prod

    // localhost and anything else: dev, as before.
    return environments.dev
}

export default getEnvironmentVariables
